module.exports = __webpack_public_path__ + "d50975b3b515c1d330ee0fd29245350a.pdf";